import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {CommonTransformationService, BenefitHistory, User, UserType, Garnishment, QueryResult} from '@app/shared';

@Injectable()
export class HrDataService {

  constructor (private http: HttpClient, private transform: CommonTransformationService) { }

  getUser(id: number): Observable<any> {
    return this.http.get<any>(`/hr/users/${id}`);
  }

  updateUser(user): Observable<any> {
    return this.http.put(`/hr/users/${user.id}`, user);
  }

  searchBenefitProviders(): Observable<any> {
    return this.http.get("/hr/benefit-providers/search?start=0&count=-1");
  }

  searchGarnishments(userId: number): Observable<QueryResult> {
    const url = `/hr/garnishments/search?user.id=${userId}`;

    return this.http.get<QueryResult>(url);
  }

  updateGarnishment(garnishments: Garnishment[]): Observable<any> {
    return this.http.put(`/hr/employees/${garnishments[0].userId}/garnishments`, garnishments);
  }

  updateBenefitHistory(benefitHistory: BenefitHistory): Observable<any> {
    return this.http.put(`/hr/employees/${benefitHistory.userId}`, benefitHistory);
  }

  getJobRequisitionCandidateInfo(userId: number): Observable<any> {
    const url = `/recruiting/job-req-candidates/info?userId=${userId}`;
    return this.http.get<any>(url);
  }

  getOversightUser(): Observable<any> {
    const url = `/hr/users/oversight-user`;
    return this.http.get<any>(url);
  }


}
